<ng-container *ngComponentOutlet="
question.value;
inputs: {
  'form': form,
  'question': question
}">
</ng-container>
